/* eslint-disable */
export var COLORS;
(function (COLORS) {
    COLORS["SAY_COBALT"] = "#1968FF";
    COLORS["SAY_COBALT_HOVER"] = "#1558D9";
    COLORS["SAY_COBALT_PRESSED"] = "#134EBF";
    COLORS["DOLPHIN"] = "#676178";
    COLORS["OVERLAY_HOVER"] = "#F6F9FF";
    COLORS["OVERLAY_PRESSED"] = "#E8F0FF";
    COLORS["OVERLAY_SELECTED"] = "#EDF3FF";
    COLORS["BLACK_OVERLAY_HOVER"] = "#F5F5F5";
    COLORS["BLACK_OVERLAY_PRESSED"] = "#E6E6E6";
    COLORS["SECONDARY"] = "#F7F7F7";
    COLORS["SECONDARY_HOVER"] = "#EBEBEB";
    COLORS["SECONDARY_PRESSED"] = "#DEDEDE";
    COLORS["DARK_HOVER"] = "#444444";
    COLORS["DARK_PRESSED"] = "#4F4F4F";
    COLORS["BLACK"] = "#000000";
    COLORS["ICE_BLUE"] = "#F0F8FF";
    COLORS["PERIWINKLE"] = "#ACC8FF";
    COLORS["TANGERINE"] = "#FFD80D";
    COLORS["DATA_VIZ_ROSE"] = "#EE5DC3";
    COLORS["DATA_VIZ_ROSE_NIGHT"] = "#BE82BE";
    COLORS["DATA_VIZ_GOLD"] = "#D08401";
    COLORS["DATA_VIZ_GOLD_NIGHT"] = "#E49101";
    COLORS["DATA_VIZ_PURPLE"] = "#5B3AB6";
    COLORS["DATA_VIZ_PURPLE_NIGHT"] = "#9F81F3";
    COLORS["DATA_VIZ_DARK_GREEN"] = "#006B39";
    COLORS["DATA_VIZ_DARK_GREEN_NIGHT"] = "#2CAA6F";
    COLORS["DATA_VIZ_LIGHT_GREEN"] = "#A9913D";
    COLORS["DATA_VIZ_GREEN"] = "#00C805";
    COLORS["DATA_VIZ_GREEN_NIGHT"] = "#00C805";
    COLORS["DATA_VIZ_ORANGE"] = "#FF5000";
    COLORS["DATA_VIZ_ORANGE_NIGHT"] = "#FF5000";
    COLORS["DATA_VIZ_PINK"] = "#D2716A";
    COLORS["DATA_VIZ_PINK_NIGHT"] = "#F0AAA5";
    COLORS["DATA_VIZ_BLUE"] = "#569FB3";
    COLORS["DATA_VIZ_BLUE_NIGHT"] = "#82C8D2";
    COLORS["DATA_VIZ_GREY"] = "#9A9393";
    COLORS["DATA_VIZ_AZURE"] = "#0087F5";
    COLORS["DATA_VIZ_AZURE_NIGHT"] = "#61B8FF";
    COLORS["DATA_VIZ_GIGAS"] = "#493997";
    COLORS["DATA_VIZ_GIGAS_NIGHT"] = "#7968CF";
    COLORS["DATA_VIZ_RED"] = "#DA7A38";
    COLORS["DATA_VIZ_RED_NIGHT"] = "#E9955C";
    COLORS["DATA_VIZ_BLUE_VIOLET"] = "#6366BB";
    COLORS["DATA_VIZ_BLUE_VIOLET_NIGHT"] = "#ADAFE0";
    COLORS["DATA_VIZ_SUSHI"] = "#879E33";
    COLORS["DATA_VIZ_SUSHI_NIGHT"] = "#ADC945";
    COLORS["DATA_VIZ_VALENCIA"] = "#D63332";
    COLORS["DATA_VIZ_VALENCIA_NIGHT"] = "#E96D6D";
    COLORS["DATA_VIZ_TAPESTRY"] = "#AF4E9E";
    COLORS["DATA_VIZ_TAPESTRY_NIGHT"] = "#B946A5";
    COLORS["DATA_VIZ_MEXICAN_RED"] = "#9B292B";
    COLORS["DATA_VIZ_MEXICAN_RED_NIGHT"] = "#D74244";
    COLORS["DATA_VIZ_SYCAMORE"] = "#A9913D";
    COLORS["DATA_VIZ_SYCAMORE_NIGHT"] = "#D0B34B";
    COLORS["DATA_VIZ_HIBISCUS"] = "#C23760";
    COLORS["DATA_VIZ_HIBISCUS_NIGHT"] = "#DF7292";
    COLORS["DATA_VIZ_FOREST"] = "#5EA173";
    COLORS["DATA_VIZ_FOREST_NIGHT"] = "#82C096";
    COLORS["LIME"] = "#EBFF6A";
    COLORS["LIGHT_GREY"] = "#EBEBEB";
    COLORS["LIGHT_TANGERINE"] = "#FFF1A9";
    COLORS["LIGHT_LIME"] = "#F5FFB9";
    COLORS["SATURATED_GREY"] = "#8B8B8B";
    COLORS["SATURATED_TANGERINE"] = "#FFC01D";
    COLORS["SATURATED_LIME"] = "#CFED0D";
    COLORS["SHADED_COBALT"] = "#002875";
    COLORS["SHADED_GREY"] = "#282828";
    COLORS["SHADED_TANGERINE"] = "#FFC01D";
    COLORS["SHADED_LIME"] = "#B2CC0B";
    COLORS["BRIGHT_YELLOW"] = "#F9FD1C";
    COLORS["BRIGHT_ORANGE"] = "#FE9D0D";
    COLORS["BRIGHT_RED"] = "#FF5050";
    COLORS["BRIGHT_PINK"] = "#FD8AFF";
    COLORS["BRIGHT_PURPLE"] = "#B67DFF";
    COLORS["BRIGHT_BLUE"] = "#4BF4FF";
    COLORS["BRIGHT_GREEN"] = "#6ACC48";
    COLORS["MERCURY"] = "#E6E6E6";
    COLORS["MUTED_YELLOW"] = "#FBF195";
    COLORS["MUTED_ORANGE"] = "#FFAA7A";
    COLORS["MUTED_RED"] = "#DD8585";
    COLORS["MUTED_PINK"] = "#FFCEE3";
    COLORS["MUTED_PURPLE"] = "#D7B9EF";
    COLORS["MUTED_BLUE"] = "#7DC5ED";
    COLORS["MUTED_GREEN"] = "#78C184";
    COLORS["LIGHT_YELLOW"] = "#FFFBD4";
    COLORS["LIGHT_ORANGE"] = "#FFE6D8";
    COLORS["LIGHT_RED"] = "#FFE5E5";
    COLORS["LIGHT_PINK"] = "#FFF0F6";
    COLORS["LIGHT_PURPLE"] = "#F6EBFF";
    COLORS["LIGHT_BLUE"] = "#E5FFFD";
    COLORS["LIGHT_GREEN"] = "#EFFFEA";
    COLORS["SATURATED_YELLOW"] = "#F4DD00";
    COLORS["SATURATED_ORANGE"] = "#E2720A";
    COLORS["SATURATED_RED"] = "#C70000";
    COLORS["SATURATED_PINK"] = "#B52AB8";
    COLORS["SATURATED_PURPLE"] = "#6D06BD";
    COLORS["SATURATED_BLUE"] = "#119CAF";
    COLORS["SATURATED_GREEN"] = "#227406";
    COLORS["SHADED_YELLOW"] = "#9F9000";
    COLORS["SHADED_ORANGE"] = "#8B4E2C";
    COLORS["SHADED_RED"] = "#7B0000";
    COLORS["SHADED_PINK"] = "#642B65";
    COLORS["SHADED_PURPLE"] = "#380462";
    COLORS["SHADED_BLUE"] = "#095560";
    COLORS["SHADED_GREEN"] = "#123D03";
    COLORS["ERROR_DARK"] = "#B00020";
    COLORS["ERROR_HOVER"] = "#9E001D";
    COLORS["ERROR_LIGHT"] = "#FF5050";
    COLORS["ERROR_PRESSED"] = "#8D001A";
    COLORS["WHITE"] = "#ffffff";
    COLORS["P_HIGH_EMPHASIS"] = "#000000";
    COLORS["P_MED_HIGH_EMPHASIS"] = "#212121";
    COLORS["P_MED_EMPHASIS"] = "#424242";
    COLORS["P_MED_LOW_EMPHASIS"] = "#666666";
    COLORS["P_DISABLED"] = "#9E9E9E";
    COLORS["S_HIGH_EMPHASIS"] = "#FFFFFF";
    COLORS["S_MED_EMPHASIS"] = "#999999";
    COLORS["S_MED_LOW_EMPHASIS"] = "#666666";
    COLORS["S_DISABLED"] = "rgba(255,255,255,0.38)";
    COLORS["SAY_DISABLED"] = "rgba(25, 104, 255, 0.38)";
    COLORS["S_OUTLINE"] = "rgba(255,255,255,0.12)";
    COLORS["P_OUTLINE"] = "#E0E0E0";
    COLORS["DISABLED_NIGHT"] = "#606060";
})(COLORS || (COLORS = {}));
export var HALO = "0px 0px 0px 2px #FFFFFF, 0px 0px 0px 3px #007FF5, 0px 0px 0px 6px rgba(0, 127, 245, 0.25)";
export var DEFAULT_SHADOW = "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)";
export var DEFAULT_SHADOW2 = "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)";
